import React, { useState } from 'react';
import { Button, Card, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { firestore } from '../../../contexts/FirebaseContext';
import useWallet from '../../../hooks/useWallet';
import { useForm } from 'react-hook-form';
import { Box } from '@mui/system';
import { styled } from '@mui/styles';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import useAuth from '../../../hooks/useAuth';
import { getSaldoType, getWalletUser, getBalanceTypeUser } from '../../../utils/formatWallet';
import useGetUserWallet from '../../../hooks/useGetUserWallet';
import { createNotification } from '../../../utils/notifications';
import { sendNotificationByUserAPI } from '../../../_apis_/notifications';
import useWalletEvents from '../../../hooks/useWalletEvents';
import useAuthUsers from '../../../hooks/useAuthUsers';

export default function DialogActionReports({ open, onClose, action, data }) {
  const { user } = useAuth();

  const handleClose = () => {
    onClose(false);
    if (action === 'aceptar') {
      createNotification(
        'Recarga de Wallet',
        `Se ha aprobado la recarga de saldo de ${data.amount}`,
        null,
        'order_placed',
        data.user_id,
        null
      );
      sendNotificationByUserAPI(data.user_id, {
        title: 'Recarga de wallet',
        message: `Se ha aprobado la recarga de saldeo de $ ${data.amount}`
      });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      //   maxWidth="md"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {/* <DialogTitle id="alert-dialog-title">Formulario para acciones reporte</DialogTitle> */}
      <DialogContent>
        {/* el admin id es el id de mi como superusuario para comprobar si el nip es valido para las acciones */}
        {action === 'aceptar' && <AcceptSection data={data} handleClose={handleClose} adminId={user?.id} />}
        {action === 'rechazar' && <DeclinetSection data={data} handleClose={handleClose} adminId={user?.id} />}
        {action === 'cancelar' && <CancelSection data={data} handleClose={handleClose} adminId={user?.id} />}
      </DialogContent>
      {/* <DialogActions>
        <Button>Aceptar reporte</Button>
      </DialogActions> */}
    </Dialog>
  );
}

function AcceptSection({ data, handleClose, adminId }) {
  const [loading, setLoading] = useState(false);
  const { recargar } = useWallet();
  const { enqueueSnackbar } = useSnackbar();
  // para obtener la wallet del usuario
  // const { userWallet } = useGetUserWallet(data.user_id);

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();
  const { handleWalletEvent, loadingWalletEvent } = useWalletEvents();
  const { verifyUserNip } = useAuthUsers();

  const acceptReport = async (dataForm) => {
    const obj = {
      nameEvent: 'ADD',
      ownerUserID: data.user_id,
      category_service_id: data.category_service_id,
      amount: data.amount,
      message: dataForm.message,
      reason: 'Reporte aceptado',
      payment_method: 'REPORT',
      payment_source: 'DAGPACKET',

      rerport_id: data.id,
      reporteAction: true,
      // para que la funcion de registrar reporte se ejecute

      // array de funciones que se ejecutan si toda va bien
      successFuncts: [handleClose],
      // si deseamos que el snackbar se muestre
      successSnackbar: true
    };

    if (verifyUserNip(dataForm.nip)) {
      handleWalletEvent(obj);
    } else {
      enqueueSnackbar('Ingrese un codigo NIP valido', { variant: 'error' });
    }
  };
  return (
    <>
      <Typography textAlign="center" variant="subtitle1">
        Aceptar reporte de pago
      </Typography>
      <Card sx={{ padding: '15px', marginTop: '15px' }} component="form" onSubmit={handleSubmit(acceptReport)}>
        <Box marginBottom="15px">
          <TextField
            type="password"
            fullWidth
            {...register('nip', { required: true })}
            variant="outlined"
            label="NIP"
          />
          {errors.nip && (
            <Typography color="error" fontSize="13px">
              Ingrese su NIP
            </Typography>
          )}
        </Box>
        <Box marginBottom="15px">
          <TextField fullWidth {...register('message', { required: true })} variant="outlined" label="Mensaje" />
          {errors.message && (
            <Typography color="error" fontSize="13px">
              Ingrese un mensaje
            </Typography>
          )}
        </Box>
        <LoadingButton loading={loadingWalletEvent} fullWidth variant="contained" type="submit">
          Aceptar reporte
        </LoadingButton>
      </Card>
    </>
  );
}

function DeclinetSection({ data, handleClose, adminId }) {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();
  const { verifyUserNip } = useAuthUsers();

  const declineReport = async (dataForm) => {
    setLoading(true);

    if (verifyUserNip(dataForm.nip)) {
      firestore
        .collection('payment_reports')
        .doc(data.id)
        .update({
          status: 'RECHAZADO',
          reject_message: dataForm.message || 'Sin mensaje',
          rejected_at: new Date(),
          updated_at: new Date()
        })
        .then(() => {
          enqueueSnackbar('Reporte rechazado', { variant: 'success' });
          // setLoading(false);
          handleClose();
        })
        .catch((error) => {
          console.log(error.response);
          setLoading(false);
          enqueueSnackbar('Se ha producido un error', { variant: 'error' });
        });
    } else {
      setLoading(false);
      enqueueSnackbar('Ingrese un codigo NIP valido', { variant: 'error' });
    }
  };
  return (
    <>
      <Typography textAlign="center" variant="subtitle1">
        Rechazar reporte de pago
      </Typography>
      <Card sx={{ padding: '15px', marginTop: '15px' }} component="form" onSubmit={handleSubmit(declineReport)}>
        <Box marginBottom="15px">
          <TextField
            type="password"
            fullWidth
            {...register('nip', { required: true })}
            variant="outlined"
            label="NIP"
          />
          {errors.nip && (
            <Typography color="error" fontSize="13px">
              Ingrese su NIP
            </Typography>
          )}
        </Box>
        <Box marginBottom="15px">
          <TextField fullWidth {...register('message', { required: true })} variant="outlined" label="Mensaje" />
          {errors.message && (
            <Typography color="error" fontSize="13px">
              Ingrese un mensaje
            </Typography>
          )}
        </Box>
        <LoadingButton loading={loading} fullWidth variant="contained" type="submit">
          Aceptar reporte
        </LoadingButton>
      </Card>
    </>
  );
}

function CancelSection({ data, handleClose, adminId }) {
  const { cobrar } = useWallet();
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  // para obtener la wallet del usuario
  // const { userWallet } = useGetUserWallet(data.user_id);
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();
  const { handleWalletEvent, loadingWalletEvent } = useWalletEvents();
  const { verifyUserNip } = useAuthUsers();

  const cancelReport = async (dataForm) => {
    const obj = {
      nameEvent: 'SUBSTRACT',
      ownerUserID: data.user_id,
      category_service_id: data.category_service_id,
      amount: data.amount,
      message: dataForm.message,
      reason: 'Reporte cancelado',
      payment_method: 'REPORT',
      payment_source: 'DAGPACKET',

      rerport_id: data.id,
      reporteAction: true,
      // para que la funcion de registrar reporte se ejecute

      // array de funciones que se ejecutan si toda va bien
      successFuncts: [handleClose],
      // si deseamos que el snackbar se muestre
      successSnackbar: true
    };

    if (verifyUserNip(dataForm.nip)) {
      handleWalletEvent(obj);
    } else {
      enqueueSnackbar('Ingrese un codigo NIP valido', { variant: 'error' });
    }
  };
  return (
    <>
      <Typography textAlign="center" variant="subtitle1">
        Cancelar reporte de pago
      </Typography>
      <Card sx={{ padding: '15px', marginTop: '15px' }} component="form" onSubmit={handleSubmit(cancelReport)}>
        <Box marginBottom="15px">
          <TextField
            type="password"
            fullWidth
            {...register('nip', { required: true })}
            variant="outlined"
            label="NIP"
          />
          {errors.nip && (
            <Typography color="error" fontSize="13px">
              Ingrese su NIP
            </Typography>
          )}
        </Box>
        <Box marginBottom="15px">
          <TextField fullWidth {...register('message', { required: true })} variant="outlined" label="Mensaje" />
          {errors.message && (
            <Typography color="error" fontSize="13px">
              Ingrese un mensaje
            </Typography>
          )}
        </Box>
        <LoadingButton loading={loadingWalletEvent} fullWidth variant="contained" type="submit">
          Cancelar reporte
        </LoadingButton>
      </Card>
    </>
  );
}
